import AbstractCanvasTransformTool from "ui/canvas/transforms/AbstractCanvasTransformTool";
import ImageTransform from "ui/canvas/ImageTransform";

/**
 * Transform layer: changes position of the layer for each selected frame
 */
export default class CanvasMove extends AbstractCanvasTransformTool {
	/**
	 * @param {number} angle
	 * @param {number} distance
	 * @param {boolean} isInteger
	 */
	constructor(angle, distance, isInteger) {
		super();
		this._angle = angle;
		this._distance = distance;
		this._isInteger = isInteger;
		this._deltaX = 0;
		this._deltaY = 0;
		this._startFrame = 0;
	}

	/**
	 * @inheritDoc
	 */
	_isNeedKeyframesForSelection(fromFrame, toFrame) {
		return fromFrame !== toFrame;
	}

	/**
	 * @inheritDoc
	 */
	async _prepare(layer, fromFrame, toFrame) {
		const len = toFrame - fromFrame;
		const angle = this._angle * Math.PI / 180;
		this._startFrame = fromFrame;
		this._deltaX = (Math.cos(angle) * this._distance) / len;
		this._deltaY = -(Math.sin(angle) * this._distance) / len;
	}

	/**
	 * @param {CanvasLayer} layer
	 * @param {number} fromFrame
	 * @param {number} toFrame
	 * @returns {void}
	 * @protected
	 */
	_processReference(layer, fromFrame, toFrame) {
		for (let i = 0, f = fromFrame + 1; f <= toFrame; f++, i++) {
			const t = new ImageTransform();
			t.translateX = this._isInteger ? Math.round(this._deltaX * i) : this._deltaX * i;
			t.translateY = this._isInteger ? Math.round(this._deltaY * i) : this._deltaY * i;
			layer.updateTransformForFrames(t, f, f);
		}
	}

	/**
	 * @inheritDoc
	 */
	_transformImage(ctx, mat, frameIndex) {
		const f = frameIndex - this._startFrame;
		if (this._isInteger) {
			mat.translate(Math.round(this._deltaX * f), Math.round(this._deltaY * f));
		} else {
			mat.translate(this._deltaX * f, this._deltaY * f);
		}
	}
}
